import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './Surveyor.scss';
import SurveyorInput from './SurveyorInput';
import SurveyorSearch from './SurveyorSearch';
import SurveyorTable from './SurveyorTable';
import { setTriggerRefreshInput, setTriggerSave } from './reducers/SurveyorInputReducer';
import { resetSurveyorSearch, setTriggerSurveyorSearch } from '../Surveyor/reducers/SurveyorSearchReducer';

let triggerHotkeyAlready = false;

const Surveyor: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    useEffect(() => {
        document.title = "Surveyor";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerSave((new Date()).getTime()));
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    case "w":
                        //search
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerSurveyorSearch((new Date()).getTime()));
                        break;
                    case "q":
                        //refresh search
                        dispatch(resetSurveyorSearch());
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid item lg={2} xs={12} className="left-search-area">
                    <SurveyorSearch></SurveyorSearch>
                </Grid>
                <Grid item lg={10} xs={12} className="right-content">
                    <Grid container className="input-fields">
                        <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                            <SurveyorInput></SurveyorInput>
                        </div>
                    </Grid>
                    <Grid container className="datatable">
                        <SurveyorTable>
                        </SurveyorTable>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
};

export default Surveyor;